import SiteMapping from '../configs/siteMapping';

const getImgLocale = (siteName, locale) => {
    const logoWithNoLocale = [SiteMapping.id8899, SiteMapping.bettha88, SiteMapping.taraPlays,
        SiteMapping.fifabet, SiteMapping.ocean99];
    if (logoWithNoLocale.includes(siteName)) {
        return 'en_w';
    }
    switch (locale) {
    case 'ch':
        return 'ch';
    case 'cs':
    case 'zhcn':
        return 'cs';
    case 'vn':
        return 'vn';

    default:
        return 'en';
    }
};

export default getImgLocale;
